import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Si es un archivo digital, ¿no es mejor comprar un mazo ya hecho?',
  answer: 'Al contrario. El mazo del kiosco es cartón barato, producido en masa para romperse y que tengas que comprar otro. Con este Master-File de ultra-resolución, el fabricante sos vos. Podés imprimirlo en un papel tan grueso que parezca una tarjeta de crédito o con un laminado premium que un mazo industrial ni sueña tener. Vos controlás la calidad, no la fábrica que quiere ahorrar costos.'
}, {
  question: 'Me da pereza tener que ir a imprimirlo... ¿es difícil?',
  answer: 'Te toma literal 5 minutos. Metés el archivo en un pendrive, vas a la gráfica del barrio, y les decís: "Imprimime esto en el papel más grueso que tengas". Salís con un mazo que se siente como de casino. El tiempo que perdés buscando un mazo oficial (que seguro está agotado o sobrevalorado por el Mundial), es el mismo que tardás en fabricar el mazo más premium de tu grupo de amigos.'
}, {
  question: '¿Qué pasa si se me moja con Fernet o se me pierde el ancho de espadas?',
  answer: 'Este es el mayor defecto de los mazos de kiosco: se arruina una carta y tenés que tirar el mazo entero. Con nuestra edición, tu mazo es inmortal. ¿Se manchó la carta de Messi? ¿El perro mordió el ancho de basto? Abrís el PDF, imprimís esa hoja de nuevo, y listo. Tenés mazo de por vida por el precio de una sola compra.'
}, {
  question: '¿Se va a ver bien o va a parecer una fotocopia barata?',
  answer: 'Está diseñado por profesionales en formato vectorial de alta fidelidad. No son fotos pixeladas bajadas de Google. Los colores son vibrantes, las líneas son nítidas y los rostros de los jugadores son arte de nivel editorial. Si lo imprimís en papel fotográfico, la calidad visual humilla a cualquier mazo de $15.000 pesos de una juguetería.'
}, {
  question: '¿El mazo de UNO también incluye a todos los jugadores?',
  answer: 'Sí. Y es la única edición donde Messi es el comodín +4 que define el partido. En el kiosco te venden el UNO genérico; acá te llevás la mística de las 3 estrellas en cada carta. Es un producto pensado para el hincha, no para la góndola de un supermercado.'
}, {
  question: '¿Realmente vale $14 dólares un archivo digital?',
  answer: 'Estás pagando por propiedad intelectual de colección y la libertad de reimpresión ilimitada. Un mazo físico de "edición especial" te lo cobran tres veces más y se degrada con el uso. Aquí pagás una vez y tenés el kit para este Mundial, el próximo, y para regalárselo a tus hijos. Es el costo de dos pizzas por un activo que no se vence nunca.'
}, {
  question: 'No tengo gráfica cerca, ¿puedo imprimirlo en mi casa?',
  answer: 'Totalmente. Está optimizado para hojas A4. Si tenés una impresora hogareña y cartulina blanca, tenés juego hoy mismo. Incluso podés plastificarlas con cinta ancha o laminado en frío casero y te quedan blindadas. Es el proyecto DIY (Hágalo usted mismo) más satisfactorio que vas a hacer este año.'
}, {
  question: '¿Este mazo va a estar disponible siempre?',
  answer: 'No. Esta es una edición limitada exclusivamente para el Mundial 2026. Una vez que termine el torneo, el servidor de descarga se cierra y el archivo desaparece del mercado. Quien lo compró, lo tiene para siempre. El que no, lo va a tener que ver en la mesa de sus amigos con envidia.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-4 bg-navy-800 relative" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-15">
          <h2 className="text-4xl md:text-6xl font-bebas text-white mb-2" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-17" />
        </motion.div>

        <div className="space-y-3" data-id="element-18">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left bg-navy-900 rounded-xl p-5 border border-white/5 hover:border-gold/30 transition-colors group" data-id="element-20">
                <div className="flex items-center justify-between gap-4" data-id="element-21">
                  <span className="text-white font-medium text-[15px] leading-snug pr-4" data-id="element-22">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-23" />
                </div>
                <AnimatePresence data-id="element-24">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-25">
                      <p className="text-white/70 text-sm leading-relaxed mt-4 pt-4 border-t border-white/5" data-id="element-26">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}